var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylNewsSearch"}},[(_vm.isMobileScreen)?_c('ylNewsSearchMobile',_vm._b({},'ylNewsSearchMobile',_vm.$attrs,false)):_c('ylNewsSearchPC',_vm._b({},'ylNewsSearchPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }